import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';

type ReturnedType = { data: [] };

type ThunkArg = {
  vehicleNumber: string;
  startdate: number | null;
  enddate: number | null;
};

interface HistoricState {
  isLoading: boolean;
  data: any;
  error: string | null;
}

const initialState: HistoricState = {
  isLoading: false,
  data: null,
  error: null
};

// Action function to get overspeed details:
export const getHistoricAction = createAsyncThunk<ReturnedType, ThunkArg>(
  'historic/get',
  async (data: any, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.GET_HISTORIC_TRACKING}deviceid=${data.vehicleNumber}&startdate=${data.startdate}&enddate=${data.enddate}`
      });
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

// Function to get historic tracking:
const historicTrackingSlice = createSlice({
  name: 'trips devices',
  initialState,
  reducers: {
    resetState: state => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getHistoricAction.pending, state => {
        state.isLoading = true;
        state.data = [];
        state.error = null;
      })
      .addCase(getHistoricAction.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.data = action.payload.data?.data;
        state.error = null;
      })
      .addCase(getHistoricAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.data = [];
        state.error = action.payload?.response?.data?.error;
      });
  }
});

export const { resetState } = historicTrackingSlice.actions;
export default historicTrackingSlice.reducer;
